import { ReducerRegistry } from '../redux';
import { HIDE_NOTIFICATION, SAVE_NOTIFICATION_MESSAGE, SET_NOTIFICATIONS_OPTION, SHOW_NOTIFICATION, } from './actionTypes';
import { SET_ACTIVE_GROUP_ID, SET_ROOM_JOINED } from '../../room';
const DEFAULT_STATE = {
    enabled: true,
    notifications: [],
    show: new Set(),
    limit: 5,
    time: 3000,
    fixMessage: undefined,
};
// 성능: 과거 모든 액션에서 전체 상태(누적 notifications 배열 포함)를 _.cloneDeep 하던 것을
// 케이스별 표적 불변 업데이트로 전환. show Set 은 반드시 새 인스턴스로 교체해야
// NotificationContainer(참조 비교)가 표시/닫힘을 감지한다.
ReducerRegistry.register('features/base/notification', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_ACTIVE_GROUP_ID:
            // DEFAULT_STATE 인스턴스 공유 오염 방지 — 컬렉션은 새 인스턴스로
            return { ...DEFAULT_STATE, notifications: [], show: new Set() };
        case SHOW_NOTIFICATION: {
            const item = {
                ...action.props,
                uid: action.uid,
            };
            const show = new Set(state.show);
            show.add(item);
            const notifications = action.props.save ? [...state.notifications, item] : state.notifications;
            return {
                ...state,
                show,
                notifications,
            };
        }
        case HIDE_NOTIFICATION: {
            const show = new Set(state.show);
            [...show.values()].map((item) => {
                if (item.uid === action.uid)
                    show.delete(item);
            });
            return {
                ...state,
                show,
            };
        }
        case SET_NOTIFICATIONS_OPTION:
            return {
                ...state,
                limit: action.limit,
                time: action.time,
            };
        case SAVE_NOTIFICATION_MESSAGE:
            return {
                ...state,
                fixMessage: action.message,
            };
        case SET_ROOM_JOINED:
            if (!action.joined) {
                return { ...DEFAULT_STATE, notifications: [], show: new Set() };
            }
            break;
    }
    return state;
});
